module.exports = __webpack_public_path__ + "static/media/partner-store-list-ic6.d019b00c.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/partner-store-list-ic6.png
// module id = 547
// module chunks = 0